'use client'

import { Lock, Home } from 'lucide-react'
import Link from 'next/link'

export default function UnauthorizedPage() {

  return (
    <main className="min-h-screen bg-gradient-to-br from-background via-background to-muted flex items-center justify-center p-4">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-72 h-72 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-72 h-72 bg-accent/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-md">
        {/* Main content card */}
        <div className="text-center space-y-8">
          {/* Lock icon */}
          <div className="flex justify-center">
            <div className="relative inline-flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20 rounded-full blur-xl"></div>
              <div className="relative bg-primary/10 border border-primary/20 rounded-full p-6">
                <Lock className="w-12 h-12 text-primary" strokeWidth={1.5} />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-3">
            <h1 className="text-5xl md:text-6xl font-bold text-foreground">403</h1>
            <p className="text-lg font-semibold text-foreground">Access Denied</p>
            <p className="text-muted-foreground leading-relaxed">
              You don&apos;t have permission to access this page. This area is restricted to authorized users only.
            </p>
          </div>

          {/* Action buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">


            <Link
              href="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors font-medium"
            >
              <Home className="w-4 h-4" />
              Home
            </Link>
          </div>

          {/* Help text */}
          <div className="pt-4 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Need help?{' '}
              <a href="/support" className="text-primary hover:underline font-medium">
                Contact support
              </a>
            </p>
          </div>
        </div>
      </div>
    </main>
  )
}
